import { SVGProps } from 'react';

export const ExpandIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    data-icon
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    {...props}
  >
    <path
      d="M8.5 1H13V5.5M5.5 13H1V8.5M13 1L8 6M1 13L6 8"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
